import type { IAccessTokenProvider } from "../../application/interfaces/IAccessTokenProvider";
import type { TokenDto } from "../../shared/TokenDto";
import type { ITokenApi } from "../../application/interfaces/ITokenApi";

export class LocalStorageTokenProvicer implements IAccessTokenProvider {
  readonly tokenStorageName = "tsm_token";
  readonly tokenApi: ITokenApi;

  constructor(tokenApi: ITokenApi) {
    this.tokenApi = tokenApi;
  }

  async getToken(): Promise<TokenDto | null> {
    const res = localStorage.getItem(this.tokenStorageName);
    if (res != null) {
      return JSON.parse(res) as TokenDto;
    } else {
      return null;
    }
  }
  // Depricated
  async getAccessToken(): Promise<string | null> {
    const token = await this.getToken();
    if (token != null) {
      return token.access_token;
    }
    return null;
  }

  async isAccessTokenExpired(): Promise<boolean> {
    // schaue 60 Sekunden voraus
    const now = Math.floor(Date.now() / 1000) + 60;
    const token = await this.getToken();
    if (token != null) {
      if (token.expires_utc > now) {
        return false 
      }
    }
    return true
  }
  async saveToken(token: TokenDto): Promise<void> {
    localStorage.setItem(this.tokenStorageName, JSON.stringify(token));
  }
  async clearToken(): Promise<void> {
    localStorage.removeItem(this.tokenStorageName);
  }
}
